import { featuredResourcesReducer } from './featured_resources/featured_resources_reducer';

const reducers = {
  featured_resources: featuredResourcesReducer,
};
export default reducers;
